module.exports = __webpack_public_path__ + "img/INTERIOR-VITARA-2.e1dfd293.jpg";